import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faKey } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Stilovi za toast
import API from "../../utils/api"; // Uvozimo API instancu
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // Navigacija nakon prijave

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Molimo unesite email i lozinku!");
      return;
    }

    try {
      setLoading(true);

      // 🟢 Axios API poziv
      const { data } = await API.post("/auth/login", { email, password });

      // ✅ Čuvamo token i korisnika u localStorage
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      toast.success("Uspešno prijavljeni!");
      setTimeout(() => navigate("https://app.smartdeals.rs/admin"), 2000); // Preusmeravanje u Admin panel
    } catch (error) {
      toast.error(error.response?.data?.message || "Neuspešna prijava!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sd__wrapper">
      {/* Notifikacije */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Logo */}
      <div className="sd__logo">
        <img
          src={require("../../assets/images/sdicon.png")}
          alt="SmartDeal Logo"
        />
      </div>

      {/* Naslov */}
      <div className="sd__title">Smart Deals</div>

      {/* Forma */}
      <form className="sd__form" onSubmit={handleSubmit}>
        <div className="sd__form-field">
          <FontAwesomeIcon icon={faUser} className="sd__icon" />
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Email adresa"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="sd__form-field">
          <FontAwesomeIcon icon={faKey} className="sd__icon" />
          <input
            type="password"
            name="password"
            id="password"
            placeholder="Lozinka"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button className="sd__btn" type="submit" disabled={loading}>
          {loading ? "Prijavljivanje..." : "Prijava"}
        </button>
      </form>

      {/* Linkovi */}
      <div className="sd__links">
        <Link to="/forgot-password">Zaboravili ste lozinku?</Link> |{" "}
        <Link to="/register">Registracija</Link>
      </div>
    </div>
  );
};

export default Login;
